<template>
<div>
	<table
        v-for="(building, index) in computed_building_tables"
        :key="index"
        class="mx-auto table-border page"
    >
		<thead>
			<tr>
				<th>Số phòng</th>
				<th>Đơn giá</th>
				<th>Ngày</th>
				<th>Tiền phòng</th>
				<th colspan="2">Điện</th>
				<th>Lượng</th>
				<th>Tiền điện</th>
				<th>Đơn giá</th>
				<th colspan="2">Nước</th>
				<th>Lượng nước</th>
				<th>Tiền nước</th>
				<th>Tiền rác</th>
				<th>Internet</th>
				<th>Xe</th>
				<th>Máy giặt</th>
				<th>Máy lạnh</th>
				<th>Tổng cộng</th>
			</tr>
		</thead>
        <tbody>
            <tr
                v-for="(bill, index2) in building"
                :key="bill.room_id + index2"
            >
                <td>{{ bill.room_id }}</td>
                <td>{{ bill.room_price | formatNumber }}</td>
                <td>{{ bill.date_count }}</td>
                <td>{{ bill.room_bill | formatNumber }}</td>
                <td>{{ bill.electric.start | formatNumber }}</td>
                <td>{{ bill.electric.end | formatNumber }}</td>
                <td>
                    {{
                        (bill.electric.end - bill.electric.start) | formatNumber
                    }}
                </td>
                <td>{{ bill.electric.total_bill | formatNumber }}</td>
                <td>{{ bill.electric.price | formatNumber }}</td>
                <td>{{ bill.water.start | formatNumber }}</td>
                <td>{{ bill.water.end | formatNumber }}</td>
                <td>
                    {{ (bill.water.end - bill.water.start) | formatNumber }}
                </td>
                <td>{{ bill.water.total_bill | formatNumber }}</td>
                <td>{{ bill.trash_bill | formatNumber }}</td>
                <td>
                    {{ bill.internet.total_bill | formatNumber | formatNumber }}
                </td>
                <td>
                    {{
                        (bill.motorbike.total_bill + bill.bike.total_bill)
                            | formatNumber
                    }}
                </td>
                <td>{{ bill.washing_machine.total_bill | formatNumber }}</td>
                <td>{{ bill.air_conditioner.total_bill | formatNumber }}</td>
                <td>{{ bill.total_bill | formatNumber }}</td>
            </tr>
        </tbody>
	</table>
    <div style="break-after: page"></div>
</div>
</template>

<script>
import { roomByBuilding } from "../../helpers/helpers";
// GB - TT - BMT - BN - A - B - MA
export default {
	name: "print-sheet-10",
	props: {
		room_data: {
			type: Array,
			default: []
		}
	},
	data() {
		return {};
	},
	computed: {
		computed_building_tables() {
            return roomByBuilding(this.room_data)
		}
	}
};
</script>

<style>
</style>